import { createContext } from 'react'

import jwtDecode from 'jwt-decode'
import { action, autorun, makeAutoObservable } from 'mobx'

import AuthService from '../../api/deprecated/authService/AuthService'
import { browserStorage, parseStorageJSON } from '../browserStorage'

export interface IUser {
  avatar?: File | null | string
  city: string
  code: string
  firstName: string
  lastName: string
  legalStatus: string
  phone: string
  userName: string
}

export interface IResponse {
  accessToken: string
  refreshToken: string
}

export type UserFromJWT = {
  IssuedAt: string
  UserId: string
  UserName: string
  UserRole: string
  exp: number
  nbf: number
}
class UserStorage {
  accessToken: null | string = parseStorageJSON(browserStorage.accessToken, null)
  isAuth: boolean | null = parseStorageJSON(browserStorage.isAuth, false)
  refreshToken: null | string = parseStorageJSON(browserStorage.refreshToken, null)
  user: UserFromJWT | null = parseStorageJSON(browserStorage.user, null)

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
    autorun(() => {
      browserStorage.user = JSON.stringify(this.user)
      browserStorage.accessToken = JSON.stringify(this.accessToken)
      browserStorage.refreshToken = JSON.stringify(this.refreshToken)
      browserStorage.isAuth = JSON.stringify(this.isAuth)
    })
  }

  @action logout() {
    browserStorage.clear()
    this.user = null
    this.accessToken = null
    this.refreshToken = null
    this.isAuth = false
  }

  @action setIsAuth(status: boolean) {
    this.isAuth = status
  }

  @action setTokens(response: IResponse) {
    this.accessToken = response.accessToken
    this.refreshToken = response.refreshToken
  }

  @action setUser(data: UserFromJWT) {
    this.user = data
  }
  get userId() {
    return this.user?.UserId
  }
}

export default createContext(new UserStorage())
